import { CartProductSchema, CartLinkedEntitlementsSchema, LinkedEntitlementRelationShipType } from '../../../types';

export type cartLinkedEntitlement = Omit<CartLinkedEntitlementsSchema, 'cloudSiteId' | 'cloudSite' | 'containerId'> & {
  logoId: string;
  name: string;
  productId?: string;
  entitlementNumber?: string;
  activeUsers: string;
  offeringName: string;
  offeringLevel?: number;
  linkedSandboxIds?: string[];
  relationshipType?: LinkedEntitlementRelationShipType;
};

export type LinkedEntitlements = cartLinkedEntitlement[];

export type Product = Omit<CartProductSchema, 'cloudSiteId' | 'cloudSite' | 'containerId' | 'isOrgProduct'> & {
  activeUsers: string;
  offeringName?: string;
  cloudSite?: string;
  offeringLevel?: number;
  linkedSandboxIds?: string[];
};

export type ContainerProductWithApps = {
  type: 'container';
  linkedEntitlements: LinkedEntitlements;
  products: Product[];
  id?: string;
};

export type StandaloneProductWithApps = Product & {
  type: 'standalone';
  linkedEntitlements: LinkedEntitlements;
  id?: string;
};

export type ProductLineItems = {
  cloudSite: string;
  cloudSiteId: string;
  products: PresentationLayerProducts;
  orgName: string;
  orgId: string;
  isOrgProduct: boolean | undefined;
}[];

export type PresentationLayerProducts = Array<StandaloneProductWithApps | ContainerProductWithApps>;

export type ProductIdPlanOptionsMap = Record<
  CartProductSchema['id'],
  {
    offeringId: string;
    offeringName: string;
    pricingPlanId: string;
    offeringLevel?: number;
  }[]
>;

export enum ProductTypeEnum {
  CONTAINER = 'container',
  STANDALONE = 'standalone',
}

export enum OfferingNameEnum {
  STANDARD = 'Standard',
  FREE = 'Free',
  PREMIUM = 'Premium',
}

export enum CartPromotionAction {
  ADD_APP_PROMOTION = 'ADD_APP_PROMOTION',
  REMOVE_APP_PROMOTION = 'REMOVE_APP_PROMOTION',
  REMOVE_PRODUCT_PROMOTION = 'REMOVE_PRODUCT_PROMOTION',
}
